export interface IParagraphEntry {
    text: string;
    x: number | null;
    width: number;
    right?: number;
    y: number;
    lineHeight: number;
    direction?: string;
}

export enum ETextAnchor {
    Left = "start",
    Middle = "middle",
    Right = "end",
}

export const svgToHtmlIgnoredAttrs = [
    "x", "dx", "y", "dy", "style", "transform", "stroke", "stroke-width", "text-anchor"
];

export const svgToHtmlMapping = {
    "fill": "color",
};

export const htmlToSvgMappings = Object.fromEntries(Object.entries(svgToHtmlMapping).map(x => x.reverse()));